export default {
    widgets: [],
    rects: []
};